import { DIRECTION_ANGLES } from '../../domains/catalog/constants/filterConstants.js'

/**
 * Classifies a product's exposition array into exposition-sides tags.
 *
 * Tags:
 *   '1'–'4+'  — number of distinct cardinal / intercardinal directions (4+ for ≥4)
 *   'corner'  — added when any two directions are exactly 90° apart
 *
 * Returns null for products with 0 exposition entries (no data → excluded from filter).
 *
 * Examples:
 *   ['N', 'E']       → ['2', 'corner']  (N-E = 90°)
 *   ['S', 'W', 'NE'] → ['3', 'corner']  (S-W = 90°)
 *   ['S', 'NE', 'N'] → ['3']            (no pair is exactly 90° apart)
 *   []               → null
 *
 * @param {string[]} exposition
 * @returns {string[] | null}
 */
export function classifyExpositionSides(exposition) {
  if (!Array.isArray(exposition) || exposition.length === 0) return null
  const count = exposition.length
  const countTag = count >= 4 ? '4+' : String(count)
  const isCorner = exposition.some((a, i) =>
    exposition.slice(i + 1).some(b => {
      const diff = Math.abs((DIRECTION_ANGLES[a] ?? 0) - (DIRECTION_ANGLES[b] ?? 0))
      return Math.min(diff, 360 - diff) === 90
    })
  )
  return isCorner ? [countTag, 'corner'] : [countTag]
}